import { createAsyncThunk } from '@reduxjs/toolkit';
import { httpService } from '../../../index';
import { executeApiRequest } from '../../asyncUtils';
import { productsActionCreators } from '../../products';
import { ITargetedCatalogApiResponse, targetedCatalogActionCreators } from '../../targetedCatalog';
import { uiActionCreators } from '../../ui';

export const fetchNewDealerTargetedCatalogThunk = createAsyncThunk(
  'newDealer/fetchTargetedCatalog',
  async (
    { newDealerRequestId, brand }: { newDealerRequestId: number; brand: string },
    { rejectWithValue, dispatch }
  ) => {
    dispatch(uiActionCreators.toggleLoading('targetedCatalog'));
    const result = await executeApiRequest<ITargetedCatalogApiResponse>(() =>
      httpService.get(`/NewDealer/${newDealerRequestId}/Orders/${brand}/Catalog`)
    );

    dispatch(uiActionCreators.toggleLoading('targetedCatalog'));

    if (result.requestFailed) {
      return rejectWithValue(`Failed to fetch targeted catalog for ${newDealerRequestId}, brand ${brand}`);
    }

    // HACK - this needs to be removed, it's temporary until we convert all the reducers to slices
    if (result.value) {
      dispatch(targetedCatalogActionCreators.setCatalog(result.value));
      dispatch(productsActionCreators.setProducts(result.value.items));
    }

    return result.value ?? [];
  }
);
